export enum BusinessPhoneVerificationChannel {
  SMS = 'sms',
  CALL = 'call'
}

export enum BusinessPhoneVerificationStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  EXPIRED = 'expired',
}

export type BusinessPhoneVerification = {
  supportedChannels: BusinessPhoneVerificationChannel[];
  selectedChannel: BusinessPhoneVerificationChannel | null;
  isPhoneNumberValid: boolean;
  isPhoneNumberVerified: boolean;
  status: BusinessPhoneVerificationStatus;
  resendLockTTLSec: number;
}
